var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.carregouMetadados)?_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }